var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "568DE86F-088D-4600-B974-A8F7A76EA7AB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Page---",
    transform: "translate(-21.000000, -63.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(21.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.375,7.5 L0.625,7.5 C0.279998789,7.5 0,7.16400145 0,6.75 C0,6.33599855 0.279998789,6 0.625,6 L14.375,6 C14.7200012,6 15,6.33599855 15,6.75 C15,7.16400145 14.7200012,7.5 14.375,7.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375,1.5 L0.625,1.5 C0.279998789,1.5 0,1.16400145 0,0.75 C0,0.335998547 0.279998789,0 0.625,0 L14.375,0 C14.7200012,0 15,0.335998547 15,0.75 C15,1.16400145 14.7200012,1.5 14.375,1.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375,13.5 L0.625,13.5 C0.279998789,13.5 0,13.1640015 0,12.75 C0,12.3359985 0.279998789,12 0.625,12 L14.375,12 C14.7200012,12 15,12.3359985 15,12.75 C15,13.1640015 14.7200012,13.5 14.375,13.5 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.26b8b0dcae45581b3d790772724bcde2.svg";
export { ForwardRef as ReactComponent };